import Layout from "../../components/layout";

function BlogPost({ post }) {
  return (
    <div className="flex-grow bg-slate-900 text-slate-200 min-h-screen">
      <Layout className="py-10">

        <h1 className="font-sans text-slate-300 font-medium md:text-3xl text-2xl text-center mb-8">
          {post.title}
        </h1>

        {post.paragraphs.map((section, index) => (
          <section key={index} className="px-2 py-4 mx-auto md:w-3/4">
            <h2 className="py-1 font-sans text-teal-300 font-medium md:text-xl text-lg">
              {section.heading}
            </h2>
            <div className="py-1 font-sans text-slate-300 leading-relaxed">
              {section.content}
            </div>
          </section>
        ))}

      </Layout>
    </div>
  );
}

export default BlogPost;